import { idtype } from "querypieces";

export default `
  ...on pageBuilder_blogFeed_BlockType {
    ${idtype}
    heading
    label
  }
`;
